export default __webpack_public_path__ + "static/media/full2.c776f28a.png";